export default function ChevronIcon({ color }: { color: 'black' | 'white' }) {
    return (
        <svg width="9" height="4" viewBox="0 0 9 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4.5 -3.93402e-07L9 4L0 4L4.5 -3.93402e-07Z"
                fill={color === 'black' ? 'black' : '#E8E4DA'}
            />
        </svg>
    );
}
